import { createFileRoute } from '@tanstack/react-router';
import { authClient } from '../lib/auth';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

function LoginPage() {
  const handleSignIn = async () => {
    await authClient.signIn.social({
      provider: 'google',
      callbackURL: `${window.location.origin}/`,
    });
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-sm rounded-lg bg-ndd-900 p-8 text-center">
        <h1 className="mb-2 text-3xl font-bold">New Day Dairy</h1>
        <p className="mb-8 text-ndd-300">Farm Management</p>
        <button
          type="button"
          onClick={handleSignIn}
          className="w-full rounded-lg bg-white px-6 py-3 text-lg font-semibold text-ndd-950 hover:bg-ndd-100 active:bg-ndd-200"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
